import React, { createContext, useContext, useState, useEffect } from "react";
import { advanceFilterData, advanceFilterList } from "./constant";
// import { isOutOfBounds } from "react-datepicker/dist/date_utils";
const createSharedState = (defaultValue = false) => {
  let listeners = [];
  let state = defaultValue;

  const setState = (newState) => {
    state = newState;
    listeners.forEach((listener) => listener(state));
  };

  const useSharedState = () => {
    const [localState, setLocalState] = useState(state);

    useEffect(() => {
      const listener = (newState) => setLocalState(newState);
      listeners.push(listener);
      return () => {
        listeners = listeners.filter((l) => l !== listener);
      };
    }, []);

    return [localState, setState];
  };

  return useSharedState;
};

export const useSharedState = createSharedState(false);

const GlobalStateContext = createContext();

let globalModalState = {
  isOpen: false,
  isEditing: false,
  data: null,
  body: null,
  hostelId: null,
  libraryId: null,
};
let globalHostelMenuState = false; // New global state
let globalAdvanceFilter = advanceFilterData;
let globalMasterTableRefresh = false;
let globalConcentModalState = { isOpen: false, body: null };
let globalRegionListUpdate = false;
// New global state
let globalLibraryMenuState = false;
let globalCanteenMenuState = false;
let globalTransportMenuState = false;
let globalChildSideBarState = true;

export const GlobalStateProvider = ({ children }) => {
  const [modalState, setModalState] = useState({
    isOpen: false,
    isEditing: false,
    data: null,
    body: null,
    hostelId: null,
    libraryId: null,
  });
  const [isChildSidebarOpen, setIsChildSidebarOpen] = useState(true);
  const [regionListUpdate, setRegionListUpdate] = useState(false);

  const [concentModalState, setConcentModalState] = useState({
    isOpen: false,
    body: null,
  });
  const [hostelMenuState, setHostelMenuState] = useState(false);
  const [libraryMenuState, setLibraryMenuState] = useState(false);
  const [canteenMenuState, setCanteenMenuState] = useState(false);
  const [transportMenuState, setTransportMenuState] = useState(false);

  const [masterTableState, setRefreshMasterTableState] = useState(false);

  const updateRegionList = () => {
    globalRegionListUpdate = !globalRegionListUpdate;
    setRegionListUpdate(!regionListUpdate);
  };

  const [_advanceFilterList, setAdvanceFilterList] =
    useState(advanceFilterList);
  const [_advanceFilterData, setAdvanceFilterData] =
    useState(advanceFilterData); // New state

  const openModal = (data) => {
    console.log("the data in the modal: ", data);
    globalModalState = data;
    setModalState(data);
  };
  const CloseChildSidebar = () => {
    globalChildSideBarState = false;
    setIsChildSidebarOpen(false);
  };
  const OpenChildSidebar = () => {
    globalChildSideBarState = true;
    setIsChildSidebarOpen(true);
  };
  const triggerChildSidebar = (bool) => {
    globalChildSideBarState = bool;
    setIsChildSidebarOpen(bool);
  };

  const openConcentModal = (Body) => {
    globalConcentModalState = { isOpen: true, body: Body };
    setConcentModalState({ isOpen: true, body: Body });
  };
  const closeConcentModal = () => {
    globalConcentModalState = { isOpen: false, body: null };
    setConcentModalState({ isOpen: false, body: null });
  };

  const updateMasterTable = () => {
    globalMasterTableRefresh = !globalMasterTableRefresh;
    setRefreshMasterTableState(!masterTableState);
  };
  const updateAdvanceFilterList = (data) => {
    globalAdvanceFilter = data;

    setAdvanceFilterList(data);
  };
  const updateAdvanceFilterData = (data) => {
    globalAdvanceFilter = data;
    setAdvanceFilterData(data);
  };
  const resetAdvanceFilterData = () => {
    globalAdvanceFilter = advanceFilterData;
    setAdvanceFilterData(advanceFilterData);
  };
  const closeModal = () => {
    globalModalState = {
      ...globalModalState,
      isOpen: false,
      isEditing: false,
      data: null,
      hostelId: null,
      libraryId: null,
    };
    setModalState({
      ...globalModalState,
      isOpen: false,
      isEditing: false,
      data: null,
      hostelId: null,
      libraryId: null,
    });
  };

  const toggleHostelMenu = (value) => {
    globalHostelMenuState = value;
    setHostelMenuState(value);
  };
  const toggleLibraryMenu = (value) => {
    globalLibraryMenuState = value;
    setLibraryMenuState(value);
  };

  const toggleCanteenMenu = (value) => {
    globalCanteenMenuState = value;
    setCanteenMenuState(value);
  };

  const toggleTransportMenu = (value) => {
    globalTransportMenuState = value;
    setTransportMenuState(value);
  };

  return (
    <GlobalStateContext.Provider
      value={{
        isChildSidebarOpen,
        CloseChildSidebar,
        OpenChildSidebar,
        triggerChildSidebar,
        regionListUpdate,
        updateRegionList,
        masterTableState,
        concentModalState,
        openConcentModal,
        closeConcentModal,

        updateMasterTable,
        resetAdvanceFilterData,
        _advanceFilterData,
        _advanceFilterList,
        updateAdvanceFilterList,
        updateAdvanceFilterData,
        modalState,
        openModal,
        closeModal,
        hostelMenuState,
        toggleHostelMenu,
        libraryMenuState,
        toggleLibraryMenu,
        canteenMenuState,
        toggleCanteenMenu,
        transportMenuState,
        toggleTransportMenu,
      }}
    >
      {children}
    </GlobalStateContext.Provider>
  );
};

export const useGlobalState = () => useContext(GlobalStateContext);
export const getGlobalModalState = () => globalModalState;
export const getGlobalHostelMenuState = () => globalHostelMenuState;
export const getGlobalAdvanceFilter = () => globalAdvanceFilter;
export const getGlobalConcentModalState = () => globalConcentModalState;
export const getGlobalRegionListUpdate = () => globalRegionListUpdate;
export const getGlobalLibraryMenuState = () => globalLibraryMenuState;
export const getGlobalCanteenMenuState = () => globalCanteenMenuState;
export const getGlobalTransportMenuState = () => globalTransportMenuState;
export const getGlobalChildSideBarState = () => globalChildSideBarState;
